import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from '../reducers/feature-key';
import { GenesysCloudNotificationState } from '../genesys-cloud-notifications.state';

export const selectState = createFeatureSelector<GenesysCloudNotificationState>(featureKey);

export const selectRetryCount = createSelector(selectState, state => state.retryCount);
